import { render } from "./UserCheckIcon.vue?vue&type=template&id=45299ab2"
import script from "./UserCheckIcon.vue?vue&type=script&lang=js"
export * from "./UserCheckIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__